{
  "endTime": "Završno vreme",
  "startTime": "Početno vreme",
  "time": "Vreme"
}
